export class Seguro {
    public deportes;
    public peso;
    public altura;
    public papellido1;
    public sapellido1;
    public pnombre1;
    public snombre1;
    public ident1;
    public porcent1;
    public parent1;
    public papellido2;
    public sapellido2;
    public pnombre2;
    public snombre2;
    public ident2;
    public porcent2;
    public parent2;
    public papellido3;
    public sapellido3;
    public pnombre3;
    public snombre3;
    public ident3;
    public porcent3;
    public parent3;
    public papellido4;
    public sapellido4;
    public pnombre4;
    public snombre4;
    public ident4;
    public porcent4;
    public parent4;

    constructor(
      ) {}
    }
  